import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import RangeToolbar, { useDateRange } from "./RangeToolbar";
import DiagnosisRuns from "./CropMonitoring/DiagnosisRuns";
import { useDemoScenario } from "../../../demo/DemoScenarioContext";
import { buildDemoDiagnosisRuns } from "../../../demo/demoDashboard";
import { useT } from "../../../i18n";
import "./Data.css";
import ReportButton from "./Reports/ReportBoard";

// 작물분석 탭(사이드바 키는 "Data"). 촬영 회차별 병해충 진단만 다룬다.
// 여기 아래에 같이 있던 장비 상태 · 에너지는 에너지 탭(Energy.jsx)으로 옮겼다.

// 데모 계정도 같은 화면을 쓴다. 예전에는 DemoData 라는 별도 화면으로 갈라져 있었는데,
// 실계정과 UI 가 달라 캡처마다 두 화면을 따로 확인해야 했다. 지금은 데이터만 갈린다.
export default function Data() {
  const t = useT();
  const farmId = useSelector((state) => state.farm.farmId);
  const { isDemo, missionLogs, demoCrop } = useDemoScenario();
  // "전체 칸" 은 정보 탭의 총 셀 수와 같은 값이어야 한다. 지도에 그려진 칸이 그 원천이다.
  const gridCellCount = useSelector((state) => state.farm.gridCells.length);
  const dateRange = useDateRange();
  const { from, to, reloadToken, periodLabel } = dateRange;

  const [isLoading, setIsLoading] = useState(true);
  const [fetchedAt, setFetchedAt] = useState(null);

  // 데모는 BE 를 타지 않는다. 실계정 응답과 같은 모양을 만들어 같은 컴포넌트에 넘긴다.
  const demoRuns = useMemo(
    () => (isDemo ? buildDemoDiagnosisRuns(missionLogs, from, to, gridCellCount, demoCrop) : null),
    [isDemo, missionLogs, from, to, gridCellCount, demoCrop]
  );

  return (
    <div className="dt-wrapper">
      <RangeToolbar dateRange={dateRange} fetchedAt={fetchedAt} isLoading={isLoading} beforeTime={<ReportButton />} />

      <div className="dt-chips">
        <span className="dt-chip">{periodLabel}</span>
      </div>

      {/* ── 병해충 ──
          확률 평균이 아니라 촬영 회차별 등급 칸 수를 보여준다.
          평균은 멀쩡한 칸이 전부 분모에 들어가 국소 발병을 지웠고,
          여러 회차를 기간으로 뭉치면 숫자가 언제 것인지 알 수 없었다.

          여기 있던 요약 4줄 / 진단 그래프 / 진단 비율은 diagnosis_probability 를 읽는데
          그 테이블에 저장하는 코드가 없어 항상 비어 있었다. TrendPanel 과 DiseasePestPanel
          컴포넌트 자체는 지우지 않았다 — 되살릴 때 그대로 쓸 수 있다. */}
      <div className="dt-container">
        <div className="dt-header">{t("data.section.pest")}</div>
        <DiagnosisRuns
          farmId={farmId}
          from={from}
          to={to}
          reloadToken={reloadToken}
          onLoadingChange={setIsLoading}
          onLoaded={setFetchedAt}
          demoData={demoRuns}
        />
      </div>
    </div>
  );
}
